import { legacy_createStore, combineReducers, applyMiddleware } from "redux";
import { thunk } from "redux-thunk";
import categoryReducer from "./reducers/category.reducer";
import authReducer from "./reducers/auth.reducer";
import shippingReducer from "./reducers/shipping.reducer";

const rootReducer = combineReducers({
  category: categoryReducer,
  auth: authReducer,
  shipping: shippingReducer,
});

export const store = legacy_createStore(rootReducer, applyMiddleware(thunk));
